export default "__VITE_ASSET__DctIeAKM__"